export const FETCH_DROP_DOWN_DATA = 'FETCH_DROP_DOWN_DATA';
export const FETCH_DROP_DOWN_DATA_SUCCESS = 'FETCH_DROP_DOWN_DATA_SUCCESS';
export const FETCH_DROP_DOWN_DATA_FAILURE = 'FETCH_DROP_DOWN_DATA_FAILURE';

export const CHANGE_SEMESTER_INDEX = 'CHANGE_SEMESTER_INDEX';
export const CHANGE_SUBJECT_INDEX = 'CHANGE_SUBJECT_INDEX';
export const CHANGE_CLASS_INDEX = 'CHANGE_CLASS_INDEX';

export const FETCH_MASTERY_PAGE_DATA = 'FETCH_MASTERY_PAGE_DATA';
export const FETCH_MASTERY_PAGE_DATA_SUCCESS =
  'FETCH_MASTERY_PAGE_DATA_SUCCESS';
export const FETCH_MASTERY_PAGE_DATA_FAILURE =
  'FETCH_MASTERY_PAGE_DATA_FAILURE';

export const FETCH_MASTERY_DATA = 'FETCH_MASTERY_DATA';
export const FETCH_MASTERY_DATA_SUCCESS = 'FETCH_MASTERY_DATA_SUCCESS';
export const FETCH_MASTERY_DATA_FAILURE = 'FETCH_MASTERY_DATA_FAILURE';

export const FETCH_MASTERY_DETAIL_DATA = 'FETCH_MASTERY_DETAIL_DATA';
export const FETCH_MASTERY_DETAIL_DATA_SUCCESS =
  'FETCH_MASTERY_DETAIL_DATA_SUCCESS';
export const FETCH_MASTERY_DETAIL_DATA_FAILURE =
  'FETCH_MASTERY_DETAIL_DATA_FAILURE';

export const FETCH_ASSESSMENT_PAGE_DATA = 'FETCH_ASSESSMENT_PAGE_DATA';
export const FETCH_ASSESSMENT_PAGE_DATA_SUCCESS =
  'FETCH_ASSESSMENT_PAGE_DATA_SUCCESS';
export const FETCH_ASSESSMENT_PAGE_DATA_FAILURE =
  'FETCH_ASSESSMENT_PAGE_DATA_FAILURE';

export const FETCH_ASSESSMENT_LIST_DATA = 'FETCH_ASSESSMENT_LIST_DATA';
export const FETCH_ASSESSMENT_LIST_DATA_SUCCESS =
  'FETCH_ASSESSMENT_LIST_DATA_SUCCESS';
export const FETCH_ASSESSMENT_LIST_DATA_FAILURE =
  'FETCH_ASSESSMENT_LIST_DATA_FAILURE';

export const FETCH_ASSESSMENT_DETAIL_DATA = 'FETCH_ASSESSMENT_DETAIL_DATA';
export const FETCH_ASSESSMENT_DETAIL_DATA_SUCCESS =
  'FETCH_ASSESSMENT_DETAIL_DATA_SUCCESS';
export const FETCH_ASSESSMENT_DETAIL_DATA_FAILURE =
  'FETCH_ASSESSMENT_DETAIL_DATA_FAILURE';

export const FETCH_STUDENT_PAGE_DATA = 'FETCH_STUDENT_PAGE_DATA';
export const FETCH_STUDENT_PAGE_DATA_SUCCESS =
  'FETCH_STUDENT_PAGE_DATA_SUCCESS';
export const FETCH_STUDENT_PAGE_DATA_FAILURE =
  'FETCH_STUDENT_PAGE_DATA_FAILURE';

export const FETCH_STUDENT_LIST_DATA = 'FETCH_STUDENT_LIST_DATA';
export const FETCH_STUDENT_LIST_DATA_SUCCESS =
  'FETCH_STUDENT_LIST_DATA_SUCCESS';
export const FETCH_STUDENT_LIST_DATA_FAILURE =
  'FETCH_STUDENT_LIST_DATA_FAILURE';

export const FETCH_STUDENT_SCORE_PAGE_DATA = 'FETCH_STUDENT_SCORE_PAGE_DATA';
export const FETCH_STUDENT_SCORE_PAGE_DATA_SUCCESS =
  'FETCH_STUDENT_SCORE_PAGE_DATA_SUCCESS';
export const FETCH_STUDENT_SCORE_PAGE_DATA_FAILURE =
  'FETCH_STUDENT_SCORE_PAGE_DATA_FAILURE';

export const SAVE_FILTER_CONDITION = 'SAVE_FILTER_CONDITION';
export const CLEAR_FILTER_CONDITION = 'CLEAR_FILTER_CONDITION';

export const fetchDropDownData = () => ({ type: FETCH_DROP_DOWN_DATA });
export const fetchDropDownDataSuccess = ({
  schoolClasses,
  semesters,
  subjects,
}) => ({
  type: FETCH_DROP_DOWN_DATA_SUCCESS,
  payload: {
    schoolClasses,
    semesters,
    subjects,
  },
});
export const fetchDropDownDataFailure = () => ({
  type: FETCH_DROP_DOWN_DATA_FAILURE,
});

export const changeSemesterIndex = index => ({
  type: CHANGE_SEMESTER_INDEX,
  payload: { index },
});
export const changeSubjectIndex = index => ({
  type: CHANGE_SUBJECT_INDEX,
  payload: { index },
});
export const changeClassIndex = index => ({
  type: CHANGE_CLASS_INDEX,
  payload: { index },
});

export const fetchMasteryPageData = () => ({ type: FETCH_MASTERY_PAGE_DATA });
export const fetchMasteryPageDataSuccess = () => ({
  type: FETCH_MASTERY_PAGE_DATA_SUCCESS,
});
export const fetchMasteryPageDataFailure = () => ({
  type: FETCH_MASTERY_PAGE_DATA_FAILURE,
});

export const fetchMasteryData = () => ({ type: FETCH_MASTERY_DATA });
export const fetchMasterySuccess = data => ({
  type: FETCH_MASTERY_DATA_SUCCESS,
  payload: { data },
});
export const fetchMasteryFailure = () => ({
  type: FETCH_MASTERY_DATA_FAILURE,
});

export const fetchMasteryDetailData = (subtopicId, semesterId, classId) => ({
  type: FETCH_MASTERY_DETAIL_DATA,
  payload: { subtopicId, semesterId, classId },
});
export const fetchMasteryDetailDataSuccess = data => ({
  type: FETCH_MASTERY_DETAIL_DATA_SUCCESS,
  payload: { data },
});
export const fetchMasteryDetailDataFailure = () => ({
  type: FETCH_MASTERY_DETAIL_DATA_FAILURE,
});

export const fetchAssessmentPageData = () => ({
  type: FETCH_ASSESSMENT_PAGE_DATA,
});
export const fetchAssessmentPageDataSuccess = () => ({
  type: FETCH_ASSESSMENT_PAGE_DATA_SUCCESS,
});
export const fetchAssessmentPageDataFailure = () => ({
  type: FETCH_ASSESSMENT_PAGE_DATA_FAILURE,
});

export const fetchAssessmentListData = () => ({
  type: FETCH_ASSESSMENT_LIST_DATA,
});
export const fetchAssessmentListSuccess = assessmentList => ({
  type: FETCH_ASSESSMENT_LIST_DATA_SUCCESS,
  payload: { assessmentList },
});
export const fetchAssessmentListFailure = () => ({
  type: FETCH_ASSESSMENT_LIST_DATA_FAILURE,
});

export const fetchAssessmentDetailData = assessmentId => ({
  type: FETCH_ASSESSMENT_DETAIL_DATA,
  payload: { assessmentId },
});
export const fetchAssessmentDetailDataSuccess = assessmentDetail => ({
  type: FETCH_ASSESSMENT_DETAIL_DATA_SUCCESS,
  payload: { assessmentDetail },
});
export const fetchAssessmentDetailDataFailure = () => ({
  type: FETCH_ASSESSMENT_DETAIL_DATA_FAILURE,
});

export const fetchStudentPageData = () => ({
  type: FETCH_STUDENT_PAGE_DATA,
});
export const fetchStudentPageDataSuccess = () => ({
  type: FETCH_STUDENT_PAGE_DATA_SUCCESS,
});
export const fetchStudentPageDataFailure = () => ({
  type: FETCH_STUDENT_PAGE_DATA_FAILURE,
});

export const fetchStudentListData = () => ({
  type: FETCH_STUDENT_LIST_DATA,
});
export const fetchStudentListDataSuccess = studentList => ({
  type: FETCH_STUDENT_LIST_DATA_SUCCESS,
  payload: { studentList },
});
export const fetchStudentListDataFailure = () => ({
  type: FETCH_STUDENT_LIST_DATA_FAILURE,
});

export const fetchStudentScoresPageData = (
  studentId,
  semesterId,
  subjectId
) => ({
  type: FETCH_STUDENT_SCORE_PAGE_DATA,
  payload: { studentId, semesterId, subjectId },
});
export const fetchStudentScoresPageDataSuccess = () => ({
  type: FETCH_STUDENT_SCORE_PAGE_DATA_SUCCESS,
});
export const fetchStudentScoresPageDataFailure = () => ({
  type: FETCH_STUDENT_SCORE_PAGE_DATA_FAILURE,
});

export const saveFilterConditions = data => ({
  type: SAVE_FILTER_CONDITION,
  payload: data,
});

export const clearFilterConditions = () => ({
  type: CLEAR_FILTER_CONDITION,
});



// WEBPACK FOOTER //
// ./app/redux/tutorDashboard/actions.js